export function parseApiError(err: any): string {
  const detail = err?.response?.data?.detail;
  if (!detail) return 'A apărut o eroare. Încearcă din nou.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg).filter(Boolean).join('; ') || 'A apărut o eroare.';
  }
  return 'A apărut o eroare. Încearcă din nou.';
}

export function calculateOver16(birthDate: string | null, manualOver16: boolean): boolean {
  if (!birthDate) return manualOver16;
  const birth = new Date(birthDate);
  const today = new Date();
  const age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();
  return age > 16 || (age === 16 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)));
}

